// src/components/FriendRequestInput.js
import React, { useState } from "react";
import { TextField } from "@mui/material";
import CustomSnackbar from "../../../../components/Shared/customSnackbar/CustomSnackbar.js";
import { sendFriendRequest } from "../../../../components/Shared/Utils/index.js";
import { isValidUsername } from "../../../../components/Shared/Utils/isValidUsername.js";
import "./FriendRequestInput.css";

const FriendRequestInput = ({ accessToken, setDisplayError, userData }) => {
  const [requestedUsername, setRequestedUsername] = useState("");
  const [snackBarDisplayMessage, setSnackBarDisplayMessage] = useState("");
  const [snackBarDisplaySeverity, setSnackBarDisplaySeverity] =
    useState("error");

  const isUsernameValid = isValidUsername(requestedUsername);
  const loggedinUser = userData.username;
  const isRequestedUsernameSameAsLoggedin = requestedUsername === loggedinUser;

  // Handlers
  const handleChange = (event) => {
    setRequestedUsername(event.target.value);
  };

  const handleCloseSnackbar = () => {
    setSnackBarDisplayMessage("");
    setSnackBarDisplaySeverity("");
  };

  const handleSendFriendRequest = async (event) => {
    event.preventDefault(); // Prevent form from submitting
    if (isRequestedUsernameSameAsLoggedin) {
      setSnackBarDisplayMessage(
        "the DRAGON looks down on you for trying to be your own friend"
      );
      setSnackBarDisplaySeverity("warning");
      return;
    }
    if (!isUsernameValid) {
      setSnackBarDisplayMessage("username is not valid");
      setSnackBarDisplaySeverity("error");
      return;
    }
    try {
      const lowercaseUsername = requestedUsername.toLowerCase();
      await sendFriendRequest(
        accessToken,
        setDisplayError,
        lowercaseUsername,
        setSnackBarDisplayMessage,
        setSnackBarDisplaySeverity,
        setRequestedUsername
      );
    } catch (error) {
      console.log("Failed to send friend request.");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent form submission on Enter key
      if (isUsernameValid) {
        handleSendFriendRequest(event);
      }
    }
  };

  return (
    <div className="FriendRequestInput">
      Add Friend
      <form onSubmit={handleSendFriendRequest} style={{ paddingTop: "1rem" }}>
        <div className="paymentInputDiv">
          <TextField
            id="standard-basic"
            label="search username"
            variant="standard"
            value={requestedUsername}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            inputProps={{
              style: {
                textTransform: "lowercase",
                width: "100%",
                margin: "0",
                color: "white",
                background: "transparent",
                boxSizing: "border-box",
                borderBottom: "1px solid grey",
              },
            }}
            InputLabelProps={{
              style: { color: "grey" },
            }}
          />
          <button
            style={{
              border: "1px grey solid",
              marginBottom: "1px",
              marginLeft: "1rem",
              width: "4rem",
              borderRadius: "10%",
              color:
                isUsernameValid && !isRequestedUsernameSameAsLoggedin
                  ? "var(--text-color)"
                  : "gray",
            }}
            type="button"
            onClick={handleSendFriendRequest}
            className="password-toggle"
          >
            ⏎
          </button>
        </div>
      </form>
      <CustomSnackbar
        open={snackBarDisplayMessage !== ""}
        message={snackBarDisplayMessage}
        severity={snackBarDisplaySeverity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default FriendRequestInput;
